document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mobile-menu a').forEach((link) => {
    link.addEventListener('click', () => {
      const menu = link.closest('details');
      if (menu) menu.removeAttribute('open');
    });
  });

  document.querySelectorAll('[data-copy-year]').forEach((node) => {
    node.textContent = new Date().getFullYear();
  });
});
